/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import FiduciaPdf from '../components/FiduciaPdfComponents';
import PdfBody from '../PdfBody';
import { IFaresAppSheet } from './interface';

export class DownloadPdf extends React.Component<IFaresAppSheet> {
  render() {
    return (
      <FiduciaPdf.Page>
        <PdfBody body={this.props.body} />
      </FiduciaPdf.Page>
    );
  }
}

export default DownloadPdf;
